export const REPORTTYPES_URL = '/repository/v2/reporttypes';
